export default __webpack_public_path__ + "static/media/resume.33602ab9.pdf";